import React from 'react';

function About() {

    return (
        <div>
        {/* // <div className="workExperience">
        //     <h1> This site is under construction 🚧👷🏼‍♀️</h1>
        //     <h2> Please check back soon!</h2> */}


        </div>
    );

}

export default About;